import React from 'react'
import { Helmet } from 'react-helmet'
import { NotificationContainer } from 'react-notifications'
import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { persistStore } from 'redux-persist'
import reducer from '../reducers'
import Routes from './Routes'
import requestMiddleware from '../actions/requestMiddleware'
import { BACKEND_URL_PREFIX } from '../utils/const'

import 'react-dropdown-tree-select/dist/styles.css'
import resetEnhancer from '../reducers/middleWares'
import 'react-responsive-modal/styles.css';
import Carousel from './Carousel'
// import 'react-tooltip/dist/react-tooltip.css';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk, requestMiddleware)))

const persistor = persistStore(store)

const originalFetch = window.fetch;

const App = () => {
  window.fetch = async (...args) => {
    let [resource, config] = args;
    let response = await originalFetch(resource, config);
    if (response.status === 502 || response.status === 503) {
      window.location.replace('/service_temporarily_unavailable');
    }
    return response;
  };
  
  return (
    <PersistGate persistor={persistor}>
      <Helmet>
        <meta charSet='utf-8' />
        <title>LMS ВУЗ</title>
        <link rel='shortcut icon' href={`${BACKEND_URL_PREFIX}/company/gou_logo`} />
      </Helmet>
      <Provider store={store}>
        <Routes />
        <Carousel/>
      </Provider>
      <NotificationContainer />
    </PersistGate>)
}

export default App
